import React, { useMemo, useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, useParams } from 'react-router-dom';

import { create, getDetail, update } from 'services/recruitment-apply.service';
import FormSection from 'components/shared/FormSection';
import { showToast } from 'utils/helpers';
import { useAuth } from 'context/AuthProvider';
import ApplicationInformation from './components/add/ApplicationInformation';
import RecruitmentInformation from './components/add/RecruitmentInformation';
import FileAttachment from './components/add/FileAttachment';
import CandidateEvaluation from './components/add/CandidateEvaluation';
import { defaultValues } from './helper/constants';

const RecruitmentApplyAddPage = () => {
  const methods = useForm({
    defaultValues: defaultValues,
  });
  const { pathname } = useLocation();
  const { recruitment_apply_id } = useParams();
  const disabled = useMemo(() => pathname.includes('/detail'), [pathname]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const [isSystem, setIsSystem] = useState(0);

  const onSubmit = async (payload) => {
    try {
      setLoading(true);
      payload.is_active = payload.is_active ? 1 : 0;
      payload.is_system = payload.is_system ? 1 : 0;

      let label;
      if (recruitment_apply_id) {
        if (!user.isAdministrator && isSystem === 1) {
          return showToast.error("Bạn không có quyền chỉnh sửa với dữ liệu hệ thống!");
        }
        await update(payload);
        label = 'Chỉnh sửa';
      } else {
        const newId = await create(payload);
        label = 'Thêm mới';
        // Redirect to edit page after create
        if (newId) {
          window._$g.rdr('/recruitment-apply/edit/' + newId);
        }
      }
      showToast.success(`${label} thành công!`);
    } catch (error) {
      showToast.error(error?.message || 'Có lỗi xảy ra!');
    } finally {
      setLoading(false);
    }
  };

  const detailForm = [
    {
      title: 'Thông tin tuyển dụng',
      component: ApplicationInformation,
      fieldActive: [
        'recruitment_id',
        'recruitment_name',
        'business_id',
        'department_id',
        'position_id',
      ],
    },
    {
      title: 'Thông tin ứng tuyển',
      component: RecruitmentInformation,
      fieldActive: [
        'full_name',
        'email',
        'phone_number',
        'dob',
        'address',
        'introduce',
        'apply_date',
      ],
    },
    {
      title: 'CV đính kèm',
      component: FileAttachment,
      fieldActive: ['file_list', 'curriculum_vitae_url'],
    },
    {
      title: 'Đánh giá ứng viên',
      component: CandidateEvaluation,
      fieldActive: ['status', 'note'],
    },
  ];

  const loadDetail = useCallback(() => {
    if (recruitment_apply_id) {
      setLoading(true);
      getDetail(recruitment_apply_id)
        .then((value) => {
          if (value) {
            methods.reset({ ...value });
            setIsSystem(value.is_system || 0);
          }
        })
        .catch((error) => {
          showToast.error(error?.message || 'Không thể tải dữ liệu!');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      methods.reset(defaultValues);
    }
  }, [recruitment_apply_id, methods]);

  useEffect(loadDetail, [loadDetail]);

  return (
    <FormProvider {...methods}>
      <FormSection loading={loading} disabled={disabled} detailForm={detailForm} onSubmit={onSubmit} />
    </FormProvider>
  );
};

export default RecruitmentApplyAddPage;
